import { Paper } from '@achieve/ascend'
import { useInlineMemoizedContentGetter } from 'utils/contentful'
import { _isEmpty } from 'utils/shared'

import { IconListItem } from 'components/IconListItem'

export const CardIconList = ({ content }) => {
  const { cardTitleText, cardBadgeImage, iconCardItemCollection } = useInlineMemoizedContentGetter(
    content,
    [
      'cardTitleText',
      'cardSubtitleText',
      'cardText',
      'cardLink',
      'secondaryCardLink',
      'cardImage',
      'cardBadgeImage',
      'iconCardItemCollection',
      'eyebrow',
      'cardJson',
    ]
  )
  if (_isEmpty(content)) return null
  const cardTitleString = cardTitleText?.json?.content?.[0]?.content[0]?.value

  return (
    <Paper
      elevation={0}
      className="bg-[#F2F5FE] lg:py-4"
      data-testid={`home-product-cards-section-card-${cardTitleString}`}
      data-paper={cardTitleString}
      data-with-badge={Boolean(cardBadgeImage)}
    >
      {iconCardItemCollection?.items && (
        <ul>
          {iconCardItemCollection?.items?.map((icon, index) => {
            return (
              <IconListItem
                key={`icon-list-item-${index}`}
                cardTitleString={cardTitleString}
                iconColor={icon.iconColor}
                iconName={icon.iconName}
                itemText={icon.description}
                noList={false}
              />
            )
          })}
        </ul>
      )}
    </Paper>
  )
}
